module.exports = __webpack_public_path__ + "img/more.07a8ec8.svg";